export const CopyrightBannerStyle: React.CSSProperties = {
    display: 'flex',
    width: '100dvw',
    background: 'rgb(222, 217, 217)',
    padding: '20px',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    zIndex: 3,
    position: 'fixed' as const,
    bottom: 0,
};

export default CopyrightBannerStyle;
